module.exports = __webpack_public_path__ + "img/tablaDiente.bc90a964.svg";